import React from 'react';
import { useCMS } from '../../context/CMSContext';
import { CheckCircle2, Info, AlertTriangle, AlertCircle, X } from 'lucide-react';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useCMS();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col space-y-2 max-w-sm w-full pointer-events-none">
      {toasts.map((toast) => {
        let bgClass = 'bg-white border-[#e2e8f0] text-white';
        let IconComponent = CheckCircle2;
        let iconColor = 'text-[#a88345]';

        if (toast.type === 'success') {
          IconComponent = CheckCircle2;
          iconColor = 'text-emerald-400';
          bgClass = 'bg-[#141d18] border-emerald-500/30 text-[#e6f4ea]';
        } else if (toast.type === 'error') {
          IconComponent = AlertCircle;
          iconColor = 'text-rose-400';
          bgClass = 'bg-[#201517] border-rose-500/30 text-[#fde8e8]';
        } else if (toast.type === 'warning') {
          IconComponent = AlertTriangle;
          iconColor = 'text-amber-400';
          bgClass = 'bg-[#201c14] border-amber-500/30 text-[#fef3c7]';
        } else {
          IconComponent = Info;
          iconColor = 'text-sky-400';
          bgClass = 'bg-[#151c24] border-sky-500/30 text-[#e0f2fe]';
        }

        return (
          <div
            key={toast.id}
            className={`pointer-events-auto border rounded-sm p-3.5 shadow-2xl backdrop-blur-md flex items-start space-x-3 text-xs transition-all animate-in slide-in-from-bottom-2 ${bgClass}`}
          >
            <IconComponent className={`w-4 h-4 shrink-0 mt-0.5 ${iconColor}`} />
            <div className="flex-1 font-sans leading-relaxed">{toast.message}</div>
            <button
              onClick={() => removeToast(toast.id)}
              className="text-[#64748b] hover:text-white shrink-0 p-0.5"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
};
